import React, { useState } from "react";
import { BiTestTube } from "react-icons/bi";
import PharmaAndLabOrderService from "../../../Services/PharmaAndLabOrderService";
import { Checkbox, message, Modal } from "antd";
import { fetchPharmacyOrders } from "../../../Redux/actions/orderActions";
import { useDispatch } from "react-redux";
import TextArea from "antd/es/input/TextArea";
import { convertUTCDateLocal } from "../../../utils/convertionFunc";

const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";

function MedicineOrdHistoryCard({ order, idx }) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMedOrder, setSelectedMedOrder] = useState(null);
  const [selectedIdx, setSelectedIdx] = useState(-1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [open, setOpen] = useState(false);
  const [orderCanMod, setOrderCanMod] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [refundable, setRefundable] = useState(true);
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("patientData");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const handleViewDetails = async (order, idx) => {
    setIsLoading(true);
    setSelectedIdx(idx);
    const payload = {
      dispensedId: order.dispensedId,
    };
    try {
      const res = await PharmaAndLabOrderService.getMedicineOrder(payload);
      setSelectedOrder(res.data);
      setOpen(true);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const handleOrderCancelMod = (medOrder) => {
    setOrderCanMod(!orderCanMod);
    setSelectedMedOrder(medOrder);
  };

  const handleCancelReason = (e) => {
    setCancelReason(e.target.value);
  };

  const handleCancelOrder = async () => {
    if (!cancelReason) {
      message.error("Please write cancellation reason.");
      return;
    }
    setLoading(true);
    const payload = {
      dispensedId: selectedMedOrder.dispensedId,
      cancelReason,
      cancelledById: loggedUser.patientId,
      cancelledByType: "USER",
      refundYN: refundable ? "Y" : "N",
      status: 9,
    };
    try {
      await PharmaAndLabOrderService.cancelMedicineOrder(payload);
      setLoading(false);
      setCancelReason("");
      setRefundable(false);
      setOrderCanMod(false);
      dispatch(fetchPharmacyOrders({ patientId: loggedUser?.patientId }));
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOrderCanMod(false);
    setSelectedMedOrder(null);
    setRefundable(false);
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  return (
    <div>
      <div
        key={idx}
        className="gap-5 items-start p-3 border rounded-md bg-gray-50"
      >
        <div className="text-red-500 text-3xl sm:text-xl mt-1">
          <BiTestTube />
        </div>
        <div>
          <div className="flex sm:flex-col justify-between sm:items-start items-center">
            <p className="text-sm sm:text-xs flex flex-col text-gray-600 mb-1">
              <label className="text-gray-400">Order ID: </label>
              <label className="text-gray-800">{order.dispensedId}</label>
            </p>
            <div className="flex flex-col gap-2">
              <p className="text-sm sm:text-xs flex  text-gray-600 mb-1">
                <label className="text-gray-400">Delivery Status:</label>
                <label className="text-gray-800">
                  {order.status === 1
                    ? "Ordered"
                    : order.status === 9
                      ? "Cancelled"
                      : "-"}
                </label>
              </p>
              <div className="text-gray-800 mb-1">
                <div className="text-sm sm:text-xs">
                  <label className="text-gray-400">Placed On:</label>
                  <label className="block sm:text-xs">
                    {order.createdDate
                      ? convertUTCDateLocal(order.createdDate)
                      : "N/A"}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="text-sm sm:text-xs flex items-center gap-2 text-gray-800">
              <button
                className="border-gray-300 text-[#189FAA] hover:text-[#338f97]"
                onClick={() => handleViewDetails(order, idx)}
              >
                View Details
              </button>
              <button
                disabled={order.status === 9}
                className="border-gray-300 sm:text-xs text-[#189FAA] hover:text-[#338f97] disabled:cursor-not-allowed disabled:opacity-50"
                onClick={() => handleOrderCancelMod(order)}
              >
                Cancel
              </button>
            </div>
            <p className="font-medium sm:text-xs">{`${CURRENCYCODE} `}{order.paidAmount?.toFixed(2)}</p>
          </div>
        </div>
      </div>

      {/* Order Details View */}
      <Modal
        width={1000}
        open={open}
        title="View Order Details"
        onCancel={() => setOpen(false)}
        footer={null}
      >
        {selectedOrder ? (
          renderModalContent(selectedOrder)
        ) : (
          <p>No order selected</p>
        )}
      </Modal>

      {/* Order Cancel */}
      <Modal
        title="Cancel Order"
        open={orderCanMod}
        onCancel={handleClose}
        footer={[]}
        destroyOnClose
      >
        <div>
          <p>
            Are you sure you want to cancel your order (Order Id :
            <span className="text-xs font-semibold text-brand-textGray">
              {selectedMedOrder?.dispensedId}
            </span>
            )
          </p>
          <label>
            Cancellation Reason <span className="text-red-500">*</span>
          </label>
          <TextArea onChange={handleCancelReason} rows={3} />
          <label className="mr-2">
            Refund Applicable<span className="text-red-500">*</span> :{" "}
          </label>
          <Checkbox
            checked={refundable}
            disabled={true}
            onChange={handleRefundable}
          >
            {/* {refundable ? 'Yes' : 'No'} */}
          </Checkbox>
          <div className="flex justify-end border-brand-colorBorder gap-3 mt-10">
            <button
              className="h-10 Btnwhite px-8 border border-[#20638e] rounded-md text-[#20638e]"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              disabled={loading}
              onClick={handleCancelOrder}
              className="mx-1 p-1 w-28 font-semibold custom_filter text-White rounded-md disabled:cursor-not-allowed disabled:opacity-50"
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const renderModalContent = (selectedOrder) => (
  <div className="p-3 border rounded-md bg-gray-50">
    <div className="flex justify-between">
      <label>Number Of Items: {selectedOrder?.length}</label>
      <label>
        Amount paid: {`${CURRENCYCODE} `}
        {selectedOrder.reduce((acc, item) => acc + item.amount, 0).toFixed(2)}
      </label>
    </div>

    <div className="flex justify-between mt-5 items-center">
      <div className="text-sm flex flex-col text-gray-600 mb-1">
        <span className="text-gray-400 text-xs">Order ID:</span>
        <span className="text-gray-800">{selectedOrder[0].dispensedId}</span>
      </div>

      <div className="text-gray-800 text-sm">
        {selectedOrder[0]?.createdDate && (
          <>
            <span className="text-gray-400 text-xs">Placed On:</span>
            <span className="block">
              {convertUTCDateLocal(selectedOrder[0]?.createdDate)}
            </span>
          </>
        )}
      </div>
    </div>

    <div className="flex justify-between">
      <div className="text-sm text-gray-600 mt-1">
        <label className="text-gray-400 font-xs">Delivery address:</label>
        <span className="text-gray-700 block">
          {selectedOrder[0].deliveryAddress}
        </span>
      </div>
      <div>
        <div className="flex gap-2 text-sm justify-center items-center mt-2 text-gray-600 mb-1">
          <span className="text-gray-400 font-xs">Delivery Status:</span>
          <span
            className={
              selectedOrder[0]?.deliveryStatus === "Pending"
                ? "text-red-400"
                : "text-green-400"
            }
          >
            {/* {selectedOrder.cartOrderDtl?.[0]?.deliveryStatus} */}
          </span>
        </div>
      </div>
    </div>

    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border">DRUG NAME</th>
            <th className="px-4 py-2 border">QTY</th>
            <th className="px-4 py-2 border">UNIT PRICE</th>
            <th className="px-4 py-2 border">UNIT DISCOUNTED PRICE</th>
            <th className="px-4 py-2 border">TOTAL AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {selectedOrder?.map((item) => (
            <tr key={item.id}>
              <td className="px-4 py-2 border">{item.drugName}</td>
              <td className="px-4 py-2 border">{item.quantity || 1}</td>
              <td className="px-4 py-2 border">
                {`${CURRENCYCODE} `}{(item.amount / item.quantity || 1).toFixed(2)}
              </td>
              <td className="px-4 py-2 border">{`${CURRENCYCODE} `}{item.discountAmount || 0}</td>
              <td className="px-4 py-2 border">{`${CURRENCYCODE} `}{item.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default MedicineOrdHistoryCard;
